import React, { useMemo } from "react";
import { COLUMNS1 } from "./ReferralColumns";
import Table from "../../../components/Table";
import "./ReferralConsultant.scss";

// @ts-ignore
function ReferralConsultant({ data }) {
  const columns = useMemo(() => COLUMNS1, [])
  /**
   * @param {any} path
   */

  return (
    <div className="referral-directory">
      <div className="consultant-directory-container">
        <Table
          data={data}
          columns={columns}
          globalFilterRequired={false}
          onRowClick={() => null}
        />
      </div>
    </div>
  )
}

export default ReferralConsultant
